/* TENDON — load-more článků blogu (progressive enhancement nad {% paginate %} gridem).
   Vzor: tdn-r-load-more.js (kolekce). Tlačítko je reálný <a href="?page=N">
   (crawlovatelné + funguje bez JS); s JS preventDefault + fetch připojí další
   stránku do #blog-grid. Odchylky od kolekčního vzoru dle UX návrhu §1.6:
   - po každém donačtení se URL pushne do historie (history.pushState);
   - čítač „Zobrazeno X z Y" se počítá z reálného počtu karet v DOM a dosazuje
     do server-rendered šablony (data-progress-template, placeholder ###) —
     text tak sedí i při přímém vstupu na ?page=N a následném donačítání.
   Navíc: aktivní chip filtru se na mobilu scrollne do view (UX návrh §1.8). */
if (!customElements.get('load-more-articles')) {
  class LoadMoreArticles extends HTMLElement {
    connectedCallback() {
      if (this.initialised) return;
      this.initialised = true;

      // S aktivním JS skryj číslované stránkování (no-JS fallback zůstává v DOM).
      if (this.dataset.hideFallback === 'true') {
        const fallback = document.querySelector('[data-lm-fallback]');
        if (fallback) fallback.hidden = true;
      }

      this.status = this.querySelector('[data-lm-status]');
      this.addEventListener('click', (evt) => {
        const trigger = evt.target.closest('[data-lm-btn]');
        if (!trigger) return;
        evt.preventDefault();
        this.loadNext(trigger);
      });
    }

    // Počet reálně zobrazených článků = karty v mřížce + případná featured karta.
    countShown() {
      const grid = document.getElementById('blog-grid');
      if (!grid) return null;
      let shown = grid.querySelectorAll(':scope > li').length;
      if (document.querySelector('[data-blog-featured]')) shown += 1;
      return shown;
    }

    // Dosaď počet z DOM do lokalizované šablony čítače (server-rendered, t filtr).
    updateProgress() {
      const template = this.dataset.progressTemplate;
      const progress = this.querySelector('[data-lm-progress]');
      if (!template || !progress) return;
      const shown = this.countShown();
      if (shown === null) return;
      progress.textContent = template.replace('###', shown);
    }

    async loadNext(link) {
      const url = link.getAttribute('href');
      if (!url || this.loading) return;
      this.loading = true;
      // Lokalizovaný text „načteno N článků" pro čtečku — server-rendered (t filtr).
      const loadedText = link.getAttribute('data-loaded-text') || '';
      link.classList.add('is-loading');
      link.setAttribute('aria-busy', 'true');

      try {
        const response = await fetch(url);
        if (!response.ok) throw new Error(`HTTP ${response.status}`);

        const tmpl = document.createElement('template');
        tmpl.innerHTML = await response.text();

        const grid = document.getElementById('blog-grid');
        const incoming = Array.from(tmpl.content.querySelectorAll('#blog-grid > li'));
        if (!grid || incoming.length === 0) { this.exhaust(link); return; }

        // Jedno připojení do DOM (bez N reflowů).
        const frag = document.createDocumentFragment();
        incoming.forEach((li) => frag.appendChild(li));
        const firstNew = frag.firstElementChild;
        grid.appendChild(frag);

        // URL state: ?page=N do historie (href z paginate.next.url zachovává
        // případnou /tagged/ cestu, takže filtr přežije sdílení i reload).
        try {
          window.history.pushState({ tdnBlogLoadMore: true }, '', url);
        } catch (e) { /* pushState může selhat jen v sandboxu — nevadí */ }

        // Aktualizuj tlačítko z čerstvého load-more elementu příští stránky
        // (texty jsou server-rendered přes t filtr — JS skládá jen číslo čítače).
        const next = tmpl.content.querySelector('load-more-articles');
        const nextLink = next ? next.querySelector('[data-lm-btn]') : null;
        if (nextLink && nextLink.getAttribute('href')) {
          link.setAttribute('href', nextLink.getAttribute('href'));
          if (nextLink.getAttribute('data-loaded-text')) {
            link.setAttribute('data-loaded-text', nextLink.getAttribute('data-loaded-text'));
          }
          this.swapText('[data-lm-label]', next);
          this.updateProgress();
        } else {
          this.exhaust(link);
        }

        // Fokus na první novou kartu — klávesnice/čtečka neztratí místo.
        if (firstNew) {
          firstNew.setAttribute('tabindex', '-1');
          firstNew.focus({ preventScroll: true });
        }
        // Stručné oznámení pro čtečku, mimo focus event.
        if (this.status && loadedText) {
          window.setTimeout(() => { this.status.textContent = loadedText; }, 150);
        }
      } catch (err) {
        if (this.status) this.status.textContent = this.dataset.errorText || '';
      } finally {
        if (link.isConnected) {
          link.classList.remove('is-loading');
          link.removeAttribute('aria-busy');
        }
        this.loading = false;
      }
    }

    swapText(selector, sourceEl) {
      const target = this.querySelector(selector);
      const source = sourceEl.querySelector(selector);
      if (target && source) target.textContent = source.textContent;
    }

    // Poslední stránka — čítač dopočítej z DOM (přesný i při vstupu na ?page=N);
    // data-complete-text zůstává jako fallback. Tlačítko odeber z DOM i z Tab pořadí.
    exhaust(link) {
      const progress = this.querySelector('[data-lm-progress]');
      if (progress) {
        const template = this.dataset.progressTemplate;
        const shown = this.countShown();
        if (template && shown !== null) {
          progress.textContent = template.replace('###', shown);
        } else if (this.dataset.completeText) {
          progress.textContent = this.dataset.completeText;
        }
      }
      if (link) link.remove();
    }
  }

  customElements.define('load-more-articles', LoadMoreArticles);
}

/* Aktivní chip filtru kategorií scrollnout do view (mobilní scroll-snap řádek).
   Bez animace (rovnou scrollLeft) — žádný pohyb pro prefers-reduced-motion. */
(function () {
  const revealActiveChip = () => {
    const row = document.querySelector('[data-blog-filter-row]');
    if (!row) return;
    const active = row.querySelector('[aria-current="page"]');
    if (!active) return;
    if (row.scrollWidth <= row.clientWidth) return;
    const rowRect = row.getBoundingClientRect();
    const chipRect = active.getBoundingClientRect();
    const target = chipRect.left - rowRect.left + row.scrollLeft - (row.clientWidth - chipRect.width) / 2;
    row.scrollLeft = Math.max(0, target);
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', revealActiveChip);
  } else {
    revealActiveChip();
  }
})();
